import { OfferPanel } from './OfferPanel';
export function EliteGift() {
  return <section className="w-full bg-navy py-12 text-white sm:py-16" data-id="element-47" data-mp="vkfleqau544h">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8" data-id="element-48" data-mp="34vsg2rs1yjf4">
        <OfferPanel data-id="element-49" data-mp="38wuh9e5j55jq" />
      </div>
    </section>;
}